(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {
        const $grid = $('.grid').imagesLoaded(function() {
            // init Packery
var $grid = $('.grid').packery({
    // Packery options...
    itemSelector: '.grid-item', 
  });
  
  // get Packery instance
  var pckry = $grid.data('packery');
  
  // init Infinite Scroll
  $grid.infiniteScroll({
  // Infinite Scroll options...
  append: '.grid-item',
  outlayer: pckry,
  path: '.next',
  history: false,
  status: '.page-load-status',
  button: '.view-more-button',
  scrollThreshold: false
});
            
        });



        /* var classes = [ 'style1', 'style2', 'style3' ]; // the classes you want to add
		$('.grid-item').each(function(i) { // the element(s) you want to add the class to.
			$(this).addClass(classes[ Math.floor( Math.random()*classes.length ) ] );
		}); */

    }

    
      
      
      $('.wf-img-gallery').slickLightbox({
        src: 'data-lightbox',
        itemSelector        : '.gallery-slide .gallery-slide-overlay',
        navigateByKeyboard  : true,
        closeOnBackdropClick : false,
        caption:function(element, info) {
            var span=$(element).parent().find(".desc");
            return span.html(); }
      });

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.grid').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=wf-masonry-block', initializeBlock );
    }

})(jQuery);